'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _index = require('components/index');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Labels.scss');

var Labels = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Labels, _Component);

  function Labels() {
    var _ref;

    (0, _classCallCheck3.default)(this, Labels);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Labels.__proto__ || (0, _getPrototypeOf2.default)(Labels)).call.apply(_ref, [this].concat(args)));

    _this.state = { visible: true };
    return _this;
  }

  (0, _createClass3.default)(Labels, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ visible: !this.state.visible });
    }

    /* eslint-disable react/no-array-index-key */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          labels = _props.labels,
          className = _props.className;
      var visible = this.state.visible;


      if (!labels || !labels.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.labelsContainer, className, (0, _defineProperty3.default)({}, styles.visible, visible)) },
        _react2.default.createElement(
          'div',
          { className: styles.labels },
          visible && labels.map(function (label, key) {
            return _react2.default.createElement(_index.Thumb, { key: key, fileName: label.subLabelLogo, urlPartName: 'label', className: styles.label });
          }),
          _react2.default.createElement(
            'div',
            { className: styles.collapser, onClick: this.toggle },
            visible ? _react2.default.createElement(
              'span',
              null,
              t('Hide'),
              ' ',
              _react2.default.createElement('i', { className: 'icon-order-up' })
            ) : _react2.default.createElement(
              'span',
              null,
              t('Show labels'),
              ' ',
              _react2.default.createElement('i', { className: 'icon-order-down' })
            )
          )
        )
      );
    }
    /* eslint-enable react/no-array-index-key */

  }]);
  return Labels;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  labels: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggle'), _class2.prototype)), _class2)) || _class);
exports.default = Labels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/Labels/Labels.js
// module id = 2039
// module chunks = 1